<template>
  <div id="form-container-type" ref="formContainer">
    <h2>Manage Attachment Type Settings</h2>

    <b-button variant="primary" class="mt-3" v-b-modal.modal-crud-attachment>New Attachment Type</b-button>

    <b-modal id="modal-crud-attachment" :no-close-on-backdrop="true" hide-header hide-footer>
      <h2>
        <span v-if="editedIndex > -1">Edit</span>
        <span v-else>New</span>
        Attachment Type
      </h2>
      <hr/>

      <form ref="form">
        <b-form-group
            v-if="editedIndex > -1"
            label="Attachment Type Code" label-for="code-input"
            invalid-feedback="Attachment Type code is required">
          <b-form-input
              id="code-input"
              v-model="editedItem.code"
              :disabled="true"
              :readonly="true"
              :aria-disabled="true"
              :aria-readonly="true"
              required>
          </b-form-input>
          <b-form-text id="name-input-help">Required.</b-form-text>
        </b-form-group>

        <b-form-group
            label="Attachment Type Name" label-for="name-input"
            invalid-feedback="Attachment Type Name is required">
          <b-form-input
              id="code-input"
              v-model="editedItem.description"
              required>
          </b-form-input>
          <b-form-text id="name-input-help">Required.</b-form-text>
        </b-form-group>

        <b-row style="margin-bottom:20px;">
          <b-col cols="3">
            <b-form-checkbox v-model="editedItem.active" name="active-switch" data-test="active-switch" switch>
              <b>Active?</b>
            </b-form-checkbox>
          </b-col>
          <b-col cols="3">
            <b-form-checkbox v-model="editedItem.internal" name="internal-switch" data-test="internal-switch" switch>
              <b>HRM Internal?</b>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-button type="button"  @click="close" style="margin-right:15px;">Cancel</b-button>
        <b-button type="button" :disabled="!isValid()" @click="save" variant="primary">Save</b-button>
      </form>

    </b-modal>

    <b-row style="max-width: 800px">
      <b-col style="text-align: right; margin-right: 20px;">
        <b-form-checkbox v-model="showInactive" name="showinactive-filter" data-test="showinactive-filter" switch>
          <b>Include inactive types?</b>
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-table
        small
        :items="attachmentTypes"
        :fields="fields"
        class="mt-2 mb-3"
        style="max-width: 800px"
    >

      <template v-slot:cell(actions)="row">
        <b-btn variant="primary" size="sm" @click="editItem(row.item)" :aria-label="'Edit ' + row.item.description">
          Edit
        </b-btn>
      </template>

      <template v-slot:cell(active)="{ item }">
        <div v-if="item.active===true">
          Yes
        </div>
        <div v-if="item.active===false">
          No
        </div>
      </template>

    </b-table>

  </div>
</template>

<script>
import axios from "axios"
import pageTitle from '@/mixins/pageTitle'

export default {
  title: 'HRM Request Application',

  data() {
    return {
      attachmentTypes: [],
      showInactive: false,
      editedIndex: -1,
      editedItem: {
        code: null,
        description: null,
        active: null,
        internal: null,
      },
      defaultItem: {
        code: '',
        description: '',
        active: '',
        internal: '',
      },
      fields: [
        {key: "code", label: "Code", sortable: true},
        {key: "description", label: "Attachment Type", sortable: true},
        {key: "active", label: "Active?", sortable: true},
        {key: "internal", label: "HRM Internal?", sortable: true},
        {key: 'actions', label: 'Actions'},
      ]
    }
  },

  watch: {
    showInactive() {
      this.loadAttachmentTypes()
    }
  },

  created() {
    this.initialize()
  },

  mixins: [
    pageTitle
  ],

  methods: {

    initialize() {
      this.loadAttachmentTypes()
    },

    loadAttachmentTypes() {
      let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/attachment/types`
      if (this.showInactive) {
        fullUrl = fullUrl + '/all'
      }
      axios.get(fullUrl)
          .then(response => {
            this.attachmentTypes = response.data
          })
    },

    editItem(item) {
      this.editedIndex = this.attachmentTypes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.$bvModal.show('modal-crud-attachment')
    },

    save() {
      if (this.editedIndex > -1) {
        axios.put(`${process.env.VUE_APP_API_BASE_URL}/attachment/type`, this.editedItem)
          .then(response => {
            this.$bvToast.toast('Attachment Type Updated', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            })
            this.loadAttachmentTypes()
            this.$root.$emit('attachmentReqChange')
          })
      } else {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/type`, this.editedItem)
          .then(response => {
            this.$bvToast.toast('Attachment Type Added', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            })
            this.loadAttachmentTypes()
            this.$root.$emit('attachmentReqChange')
          })
      }
      this.close()
    },

    close() {
      this.$bvModal.hide('modal-crud-attachment')
      this.editedIndex = -1
      this.editedItem = this.defaultItem
    },

    isValid() {
      if(this.editedItem.description) {
        return true
      } else
        return false
    }
  }
}


</script>